import { Color } from 'csstype'
import { maxBy } from 'lodash'
import { isUndefinedOrNull } from 'util/checks'
import { CidadaoListagemGestantePuerperaQueryModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-gestantePuerpera'

import { AcompanhamentoCondicaoSaudeVacinasSection } from '../AcompanhamentoCondicaoSaudeVacinasSection'
import { GRUPOS_IMUNOBILIOGICO_GESTANTE_PUERPERA } from '../model-acompanhamentoCondicaoSaudeAccordion'
import { AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSection'
import { AcompanhamentoCondicaoSaudeGestantePuerperaExamesSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaExamesSection'
import { AcompanhamentoCondicaoSaudeGestantePuerperaInfoSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaInfoSection'
import { AcompanhamentoCondicaoSaudeGestantePuerperaMedicoesSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaMedicoesSection'
import { AcompanhamentoCondicaoSaudeGestantePuerperaVisitasDomiciliaresSection } from './AcompanhamentoCondicaoSaudeGestantePuerperaVisitasDomiciliaresSection'

interface AcompanhamentoCondicaoSaudeGestantePuerperaAccordionSectionProps {
  row: CidadaoListagemGestantePuerperaQueryModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeGestantePuerperaAccordionSection(
  props: Readonly<AcompanhamentoCondicaoSaudeGestantePuerperaAccordionSectionProps>
) {
  const { row, iconColor } = props
  const gestantePuerpera = row.cidadao?.cidadaoConsolidado?.preNatalPuerperio
  const vacinas = gestantePuerpera?.vacinasAplicadas

  const vacinaMaisRecente = maxBy(vacinas, (vacina) => vacina.dataRegistroVacinaAplicada)

  return (
    <>
      <AcompanhamentoCondicaoSaudeGestantePuerperaInfoSection
        gestantePuerpera={gestantePuerpera}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeVacinasSection
        vacinas={isUndefinedOrNull(vacinaMaisRecente) ? [] : [vacinaMaisRecente]}
        grupos={GRUPOS_IMUNOBILIOGICO_GESTANTE_PUERPERA}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeGestantePuerperaMedicoesSection
        medicoesPreNatal={gestantePuerpera?.medicoesPreNatal}
      />
      <AcompanhamentoCondicaoSaudeGestantePuerperaExamesSection
        examesRealizadosPreNatal={gestantePuerpera?.examesRealizadosPreNatal}
        iconColor={iconColor}
      />
      <AcompanhamentoCondicaoSaudeGestantePuerperaVisitasDomiciliaresSection
        visitasDomiciliares={gestantePuerpera?.visitasDomiciliares}
      />
      <AcompanhamentoCondicaoSaudeGestantePuerperaConsultasPuerperioSection
        atendimentosPreNatalPuerperio={gestantePuerpera?.atendimentosPreNatalPuerperio}
        dataUltimaConsultaPuerperio={gestantePuerpera?.atendimentosPreNatalPuerperio?.dataUltimaConsultaPuerperio}
      />
    </>
  )
}
